import { defaultImage } from "../productUtils/ProductUtils";
// import { defaultImage } from "/images/product-image-not-found-img.webp";

export const productImageFunc = (imgPath2, companyDetails) => {
  let imgPath = imgPath2;
  // let productImage = defaultImage;
  let productImage = "/images/product-image-not-found-img.webp";

  imgPath =
    imgPath2 == "/icons/default-image.svg"
      ? "/images/product-image-not-found-img.webp"
      : imgPath2;

  if (imgPath) {
    const imageServer = companyDetails.response.imageServer;
    const imagePath = imgPath;
    const s3Prefix =
      "https://s3-us-west-2.amazonaws.com/vasyerpsolutions4/local/Gmart/product-image-pv/";

    if (imageServer === "S3" && imagePath.startsWith(s3Prefix)) {
      productImage = imagePath.replace(
        s3Prefix,
        "https://ik.imagekit.io/6gua1wejtw0/"
      );
    } else if (
      imagePath.includes("vasyerpsolutions4/local/Gmart/product-image-pv/")
    ) {
      productImage = imagePath.replace(
        "vasyerpsolutions4/local/Gmart/product-image-pv/",
        "https://ik.imagekit.io/6gua1wejtw0/"
      );
    } else {
      productImage = imagePath;
    }
  }
  return productImage;
};
